<template>
  <div class="MyAccountPage_PaymentDetails">
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>
    <template v-else>
      <h2 class="title">{{ $t('myaccount.paymentDetails.title', 'Payment details') }}</h2>
      <template v-if="hasPaymentProfile">
        <div class="PaymentDetails_body">
          <div class="MyAccountForm">
            <payment-information />

            <app-button
              :disabled="this.showPaymentMethodBody"
              @click="toggleButtonStatus"
              @click.native="trackConversion({ name: 'interaction', description: 'change_payment_method' })"
              data-name="myAccountPaymentDetail-toggleButton"
              :class="{'grey-color': paymentActivity.hasPaymentInProgress}"
              @mouseleave="mouseleave"
              @mouseover="mouseover"
            >
              {{ $t('myaccount.paymentDetails.button', 'Change payment method') }}
            </app-button>

            <v-popover
              offset="15"
              trigger="manual"
              placement="bottom-right"
              :open="isOpen"
              popover-wrapper-class="paymentDetail_poptip"
            >
              <template slot="popover">
                <div>{{ $t('common.paymentInprogress.toolTips.text', 'This option is disabled as we are processing your latest payment') }}</div>
              </template>
            </v-popover>
          </div>

          <div class="PaymentMethod_body" v-if="showPaymentMethodBody">
            <h3 class="title5">
                {{ $t('checkout.payment.subTitle.selectMethod', 'Select payment method') }}
              </h3>
            <payment-methods
              :sbeflag = {sbeflag}
              @payment-method-selected="setPaymentMethod($event)"
              :payment-method-submit-active="updatePaymentMethodTask.isActive"
            />

            <div class="btn-wrap flex-between">
              <app-button
                type="submit"
                @click.prevent="updatePaymentMethodTask.run()"
                :is-loading="taskIsActive"
                :disabled="paymentMethodCode === null || taskIsActive"
                @click.native="trackConversion({
                  name: 'interaction', description: `payment_method:${paymentMethodName}:change_payment_method`
                })"
                data-name="myAccountPaymentMethods-submitButton"
              >
                {{ $t('myaccount.paymentDetails.paymentMethod.SubmitButton', 'Submit') }}
              </app-button>

              <app-button
                @click="toggleButtonStatus"
                @click.native="trackConversion({ name: 'interaction', description: 'change_payment_method:cancel' })"
                data-name="myAccountPersonalMethod-cancelButton"
              >
                {{ $t('myaccount.paymentDetails.paymentMethod.CancelButton', 'Cancel') }}
              </app-button>
            </div>
            <div>
              <br>
        <div id="payment-page">
         <div class="container">
           <div class="payment-container">
             <div id="dropin-container">
            </div>
          </div>
        </div>
       </div>
      </div>

            <div ref="paymentForm" v-html="paymentForm" v-show="false"></div>
          </div>
        </div>

        <div
          class="privacyDeclaration"
          v-html="$t('myaccount.privacyDeclaration.text')">
        </div>
      </template>

      <p v-else class="empty-data">
        {{ $t('myaccount.paymentDetails.body.emptyData', 'Sorry, you do not have zuora account or your payment details have not synchronize yet!') }}
      </p>
    </template>

    <!-- <template v-if="currentCountryCode === 'GB' && sbeCompliance !== 'True' || currentCountryCode === 'NL' && sbeCompliance !== 'True' || currentCountryCode === 'DE' && sbeCompliance !== 'True'">
       <app-modal name="sbecompliancemodal" :clickToClose="false" width="500px" :no-close-on-backdrop="true" @before-close="true">
            <div class="v--modal-content">
              <div class="newFlowForCancelReplenishment_popUp"> 
                <div class="sbeTC" v-html="$t('checkout.noPayment.button.decline.sbeterms')"> </div>
                 <div class="modal-button-wrapper">
                  <app-button
                    :disabled="this.showPaymentMethodBody"
                    @click="Acceptpaymentmethod"
                    data-name="myAccountPaymentDetail-toggleButton"
                    :class="{'grey-color': paymentActivity.hasPaymentInProgress}"
                    @mouseleave="mouseleave"
                    @mouseover="mouseover"
                    >  {{ $t('checkout.noPayment.button.confirmOrder.sbe', 'Confirm') }}
                  </app-button>
                </div>
              </div>
            </div>
      </app-modal>
      </template> -->

  </div>
</template>

<script>
  import { extractErrorMessage } from '@/utilities/common'
  import PaymentMixin from 'mixins/payment'
  import { detectedCulture } from 'utilities/common/culture'
  import Vue from 'vue'
  import { mapGetters,mapState} from 'vuex'
  import AdyenCheckout from '@adyen/adyen-web';
  import '@adyen/adyen-web/dist/adyen.css'; 

  export default {
    name: 'payment-details',

    mixins: [PaymentMixin],

    data () {
      return {
        showPaymentMethodBody: false,
        cancelPaymentUrl: window.location.href,
        currentCountryCode: detectedCulture.countryCode, 
        isOpen: false,
        sbeflag:false
      }
    },

    computed: {
      ...mapGetters('account', ['paymentActivity']),
      ...mapState('account', {  
        sbeCompliance: state => state.profile.personalDetail.sbeCompliance
      }) 
    },

    watch: {
      paymentActivity (newVal, oldVal) {
        if (oldVal.hasPaymentInProgress && !newVal.paymentActivity) {
          this.fetchMyPaymentMethod()
        }
      }
    },

    methods: {
      toggleButtonStatus () {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.showPaymentMethodBody = false
        } else {
          this.showPaymentMethodBody = !this.showPaymentMethodBody
          this.paymentMethodCode = null
        }
      },
       Acceptpaymentmethod(){
         this.$bus.$emit('close-modal', 'sbecompliancemodal')
         this.sbeflag = 'True'
         this.$store.commit('account/setsbeCompliance','True') 
           if (this.paymentActivity.hasPaymentInProgress) {
          this.showPaymentMethodBody = false
        } else {
          this.showPaymentMethodBody = !this.showPaymentMethodBody
          this.paymentMethodCode = null
        }
       }, 

        Deniedpaymentmethod(){
        this.$bus.$emit('close-modal', 'sbecompliancemodal')
        this.sbeflag = 'False'
        this.$store.commit('account/setsbeCompliance','False') 
          if (this.paymentActivity.hasPaymentInProgress) {
          this.showPaymentMethodBody = false
        } else {
          this.showPaymentMethodBody = !this.showPaymentMethodBody
          this.paymentMethodCode = null
        }
       }, 
      mouseleave () {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.isOpen = false
        }
      },
      mouseover () {
        if (this.paymentActivity.hasPaymentInProgress) {
          this.isOpen = true
        }
      }
    },

    tasks (t) {
      return {
        updatePaymentMethodTask: t(async function () {
          this.taskIsActive = true
           let provider = this.paymentMethodCode.split('.')[0]
          if (provider === 'Adyen') {
          await Vue.api.account.changePaymentMethod(this.paymentMethodCode, this.cancelPaymentUrl,this.sbeCompliance).then(data => {
          localStorage.setItem('ordernumber', data.orderNumber);
         }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
        await Vue.api.account.adyenchangeprofile(provider, this.paymentMethodCode, this.sbeCompliance, window.localStorage.getItem('ordernumber')).then(data => {
        localStorage.setItem('sessionID', data.id);
        localStorage.setItem('sessiondata', data.session);
        localStorage.setItem('Client', data.clientKey);
        localStorage.setItem('Env', data.environment);
       
      }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
      
  let brandcode = this.paymentMethodCode.split('.')[1]
  const cardConfiguration = {
   hasHolderName: true,
   holderNameRequired: true,
  
   
   brands:[brandcode],
   
};
  const configuration = {
  environment: window.localStorage.getItem('Env'),
  clientKey: window.localStorage.getItem('Client'),
  showPayButton: true,
  session: {
    id: window.localStorage.getItem('sessionID'), 
    sessionData: window.localStorage.getItem('sessiondata'),
   
  },
  onPaymentCompleted: (result, component) => {

   if(result.resultCode === 'Authorised'){

     Vue.prototype.$notify({
                type: 'success',
                title: Vue.prototype.$t('popuptips.paymentMethod.update.successful', 'update payment method successfully, new payment method info will updated to account in few minutes'),
                duration: 5000
              })
            } else {
              Vue.prototype.$notify({
                type: 'error',
                title: Vue.prototype.$t('popuptips.paymentMethod.update.failed', 'failed to update payment method'),
                duration: 5000
              })
            }
            setTimeout(() => {
              window.location.href = `${window.location.origin}/${this.$router.options.base}/my-account/payment-details`
            }, 3000)

      console.info(result, component);
  
  },
  onError: (error, component) => {
      console.error(error.name, error.message, error.stack, component);
  },
 
  paymentMethodsConfiguration: {
    card: cardConfiguration
  }
};

// Create an instance of AdyenCheckout using the configuration object.
const checkout = await AdyenCheckout(configuration);

// Create an instance of Drop-in and mount it to the container you created.
const dropinComponent = checkout.create('dropin').mount('#dropin-container');

          }
          else {
          await Vue.api.account.changePaymentMethod(this.paymentMethodCode, this.cancelPaymentUrl,this.sbeCompliance).then(paymentCallBack => {
            this.paymentForm = paymentCallBack.htmlForm
          })
          }
        }).onError(function (task) {
          this.taskIsActive = false
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('drop')
      }
    },

    created () {
      this.fetchMyPaymentMethod()
     },

    mounted(){  
      if(this.currentCountryCode === 'US' || this.currentCountryCode === 'CA' || this.currentCountryCode === 'PL' ){
        this.sbeCompliance = 'NA'
      }
       if(this.currentCountryCode === 'AT' || this.currentCountryCode === 'IT' || this.currentCountryCode === 'BE' || this.currentCountryCode === 'ES'  ){
        this.sbeCompliance = 'True'
      }
         this.$bus.$emit('open-modal', 'sbecompliancemodal') 
    }
  }
</script>

<style lang="scss">
  .MyAccountPage {
    &_PaymentDetails {
      .title {
        padding: 0 .15rem .12rem;
        border-bottom: .01rem solid #9b9b9b;
      }

      .PaymentMethod {
        &_body {
          margin-top: .18rem;

          .btn-wrap {
            .AppButton {
              width: 47%;
              min-width: auto;
            }
          }
        }
      }

      .sbeTC {
        font-weight: 700;

        ul {
          margin: 0.1rem 0.2rem 0.2rem 0.2rem;
        }

        ul li {
          display: block;
          height: 15px;
        }
      }

      .modal-button-wrapper {
        display: flex;
        overflow: hidden;

        .AppButton {
          margin: 0 auto;
          width: 2rem;
          min-width: 2rem;
        }
      }

      .newFlowForCancelReplenishment_popUp {
        .modal-title {
          margin: 0.2rem 0;
          text-align: center;
        }
      }

      .v--modal-box {
        .closeButton {
          display: none;
        }
      }

      @include media(tablet) {
        .AppButton {
          min-width: 2.65rem;
          line-height: 1.15;
        }

        .PaymentMethod {
          &_card {
            display: block;

            &-notCredit {
              margin-bottom: .28rem;
            }

            &-credit {
              margin-left: 0;
            }
          }
        }
      }

      @include media(desktop) {
        .PaymentMethod {
          &_card {
            display: flex;

            &-notCredit {
              flex: 1;
              margin-bottom: 0;

              + .PaymentMethod_card-credit {
                margin-left: .4rem;
              }
            }

            &-credit {
              flex: 1;
            }
          }
        }
      }

      .grey-color {
        background: #d8d8d8 !important;
        cursor: default;
      }
    }
  }

  .paymentDetail_poptip {
    top: -.33rem;
    left: .2rem;
    position: absolute;
    background: white;
    min-width: 2.09rem;

    @include media(tablet) {
      top: -.33rem;
      left: 1rem;
      position: absolute;
      background: white;
      min-width: 2.26rem;
    }

    .tooltip-arrow {
      @include media(tablet) {
        left: calc(20% - 9px) !important;
      }

      @include media(desktop) {
        left: calc(20% - 9px) !important;
      }
    }
  }
</style>
